export enum ClimateType {
  TemperateContinental = 'TemperateContinental',
  TemperateOceanic = 'TemperateOceanic',
  Subtropical = 'Subtropical',
  Tropical = 'Tropical'
}
